/** @format */

import React, { useRef } from 'react';
import ReactLoading from 'react-loading';

const FallbackLoading = () => {
	const ref = useRef(null);
	return (
		<div className='w-full bg-slate-100 h-screen flex justify-center items-center'>
			<ReactLoading
				type={'balls'}
				height={'30px'}
				width={'60px'}
				color={'#00000'}
				ref={ref}
			/>
		</div>
	);
};

export default FallbackLoading;
